import { fetchV3 } from "./client";

export const searchByUrl = (url, search) =>
  fetchV3({
    url,
    body: { search },
    useLoading: false,
  });
